class Excel {
  static download = (option: {blod?: BlobPart, fileName?: string, originalName?: string}) => {
    const { blod, fileName, originalName } = option;
    if (!blod) return;

    const outputFilename = originalName ? `${originalName}.xlsx` : `${fileName}_${new Date().getTime()}.xlsx`;
    const url = URL.createObjectURL(new Blob([blod]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
}

export default Excel;
